import { render, staticRenderFns } from "./template.html?vue&type=template&id=08c9670a&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "../ICheckable/style.scss?vue&type=style&index=0&id=08c9670a&lang=scss&scoped=true&"
import style1 from "./style.scss?vue&type=style&index=1&id=08c9670a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c9670a",
  null
  
)

export default component.exports